import React, { FC } from 'react'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'

import AspectRatioIcon from '@material-ui/icons/AspectRatio'
import EqualizerIcon from '@material-ui/icons/Equalizer'
import PeopleAltIcon from '@material-ui/icons/PeopleAlt'
import FeaturedPlayListIcon from '@material-ui/icons/FeaturedPlayList'

import { components } from '@plandi/common/src/generated'
import { useLocale } from '@plandi/common'
import { useProfileDetailsStyles } from './profile-details.styles'

type ProfileStructureProps = {
  profileFactory?: components['schemas']['ProfileFactoryMeResource']
}

export const ProfileStructure: FC<ProfileStructureProps> = ({
  profileFactory
}) => {
  const classes = useProfileDetailsStyles()
  const locale = useLocale()

  const renderStructure = () => {
    return (
      <>
        <Typography
          variant="subtitle1"
          color="primary"
          className={classes.title}
        >
          {locale === 'ru' ? 'Структура завода' : 'Plant structure'}
        </Typography>
        {profileFactory?.structure?.area && (
          <div className={classes.textWrap}>
            <AspectRatioIcon fontSize="small" className={classes.icon} />
            <Typography
              className={classes.text}
              variant="body2"
              component="span"
            >
              {`${locale === 'ru' ? 'Заводская площадь' : 'Factory square'}: ${
                profileFactory?.structure.area
              } ${locale === 'ru' ? 'кв. м.' : 'sq. m.'}`}
            </Typography>
          </div>
        )}
        {profileFactory?.structure?.volume && (
          <div className={classes.textWrap}>
            <EqualizerIcon fontSize="small" className={classes.icon} />
            <Typography
              className={classes.text}
              variant="body2"
              component="span"
            >
              {`${locale === 'ru' ? 'Годовой объём' : 'Annual volume'}: ${
                profileFactory?.structure.volume
              } ${
                locale === 'ru' ? 'тыс. шт или тонн' : 'thousand pieces or tons'
              }`}
            </Typography>
          </div>
        )}
        {profileFactory?.structure?.employees && (
          <div className={classes.textWrap}>
            <PeopleAltIcon fontSize="small" className={classes.icon} />
            <Typography
              className={classes.text}
              variant="body2"
              component="span"
            >
              {`${
                locale === 'ru' ? 'Количество работников' : 'Amount of workers'
              }: ${profileFactory?.structure.employees} ${
                locale === 'ru' ? 'чел.' : 'people'
              }`}
            </Typography>
          </div>
        )}
        {profileFactory?.structure?.year && (
          <div className={classes.textWrap}>
            <FeaturedPlayListIcon fontSize="small" className={classes.icon} />
            <Typography
              className={classes.text}
              variant="body2"
              component="span"
            >
              {`${
                locale === 'ru'
                  ? 'Год основания завода'
                  : 'Year the plant was founded'
              }: ${profileFactory?.structure.year}`}
            </Typography>
          </div>
        )}
      </>
    )
  }

  return (
    <Card className={classes.card}>
      <CardContent>{renderStructure()}</CardContent>
    </Card>
  )
}
